<template>
  <card ref="bcq-context-menu" role="menu" tag="div" :elevation="elevation" v-if="items.length" :class="[baseCss, 'absolute', 'transition-opacity', 'duration-300', visible ? ['opacity-100'] : ['opacity-0', 'pointer-events-none']]" :style="style">
    <card-text padding-off>
      <list>
        <list-item :disabled="item.disabled" v-for="(item, index) in items" :key="index" @click="onItemClick(item)">
          <list-item-icon v-if="item.icon">
            <icon :name="item.icon" :provider="iconProvider" />
          </list-item-icon>
          <list-item-content>
            <list-item-content-title v-if="item.title">{{ item.title }}</list-item-content-title>
            <list-item-content-sub-title v-if="item.subTitle">{{ item.subTitle }}</list-item-content-sub-title>
          </list-item-content>
        </list-item>
      </list>
    </card-text>
  </card>
</template>
<script>
import methods from '../../mixins/methods'
import props from '../../mixins/props'

export default {
  name: 'ContextMenu',
  mixins: [
    props,
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('context-menu', []),
      menuWidth: null,
      menuHeight: null,
      top: 0,
      left: 0,
      visible: false
    }
  },
  computed: {
    style () {
      return {
        zIndex: this.zIndex,
        width: this.width,
        top: this.top,
        left: this.left
      }
    }
  },
  props: {
    items: {
      type: Array,
      default: () => {
        return []
      }
    },
    zIndex: {
      type: Number,
      default: 1000
    },
    contextData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    width: {
      type: String,
      default: '220px'
    }
  },
  created () {
    document.addEventListener('click', this.documentClick)
  },
  destroyed () {
    document.removeEventListener('click', this.documentClick)
  },
  methods: {
    documentClick (e) {
      const contextMenu = 'bcq-context-menu'
      let el = this.$refs[contextMenu]
      let target = e.target
      if (el !== target && !e.target.classList.contains(contextMenu)) {
        this.visible = false
      }
    },
    onItemClick (item) {
      this.$emit('item-click', {
        item,
        contextData: this.contextData
      })
      this.hide()
    },
    show ($event) {
      const menu = this.$el
      const offset = 2
      if (!this.menuWidth || !this.menuHeight) {
        this.menuWidth = menu.offsetWidth
        this.menuHeight = menu.offsetHeight
      }
      if ($event && $event.type === 'contextmenu') {
        $event.preventDefault()
      }
      if (this.menuWidth + $event.pageX >= window.innerWidth) {
        this.left = $event.pageX - this.menuWidth + offset + 'px'
      } else {
        this.left = $event.pageX - offset + 'px'
      }
      if (this.menuHeight + $event.pageY >= window.innerHeight) {
        this.top = $event.pageY - this.menuHeight + offset + 'px'
      } else {
        this.top = $event.pageY - offset + 'px'
      }
      this.visible = true
    },
    hide () {
      this.visible = false
    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/context-menu/context-menu.vue